import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';

import { contentHeaders, config } from '../config';

import { DcSpinnerService } from './spinner.service';

@Injectable()
export class RequestService {
  static isRefreshingToken = null;
  static nbActiveRequest = 0;

  public activeRequest = null;

  constructor(public http: Http, public router: Router, public spinnerService: DcSpinnerService) {
  }

  public post(url, body = {}): any {
    let args = [this.transformUrl(url, true), JSON.stringify(body), { headers: contentHeaders }];
    let originalArgs = [url, body];
    return this.handleRequest(this, 'post', args, originalArgs);
  }

  public put(url, body = {}): any {
    let args = [this.transformUrl(url), JSON.stringify(body), { headers: contentHeaders }];
    let originalArgs = [url, body];
    return this.handleRequest(this, 'put', args, originalArgs);
  }

  public get(url, spinner = true): any {
    let args = [this.transformUrl(url), { headers: contentHeaders }];
    let originalArgs = [url];
    return this.handleRequest(this, 'get', args, originalArgs, spinner);
  }

  public delete(url): any {
    let args = [this.transformUrl(url), { headers: contentHeaders }];
    let originalArgs = [url];
    return this.handleRequest(this, 'delete', args, originalArgs);
  }

  public getPaginatedUrl(url, page, max) {
    if (page === 0 && max === 0) {
      return url;
    }
    let separator = '?';
    if (url.indexOf('?') > -1) {
      separator = '&';
    }
    url += `${separator}page=${page}&page_size=${max}`;
    return url;
  }

  public startSpinner() {
    RequestService.nbActiveRequest++;
    this.spinnerService.start();
  }

  public stopSpinner() {
    RequestService.nbActiveRequest--;
    if (RequestService.nbActiveRequest <= 0) {
      this.spinnerService.stop();
    }
  }

  public transformUrl(url, useCurent = false) {
    if (url.indexOf('://') === -1) {
      url = config.baseApi + url;
    }

    if (url.indexOf('access_token') > -1) {
      return url;
    }

    let accessToken = localStorage.getItem('auth_access_token');
    if (accessToken) {
      let separator = '?';
      if (url.indexOf('?') > -1) {
        separator = '&';
      }
      url += `${separator}access_token=${accessToken}`;
    }

    return url;
  }

  public stopRequest(request = null) {
    if (request !== null) {
      request.unsubscribe();
      this.stopSpinner();
      return;
    }
    if (this.activeRequest) {
      this.activeRequest.unsubscribe();
      this.stopSpinner();
    }
    this.activeRequest = null;
  }

  public getActiveRequest () {
    return this.activeRequest;
  }

  public parseMessage(response) {
    if (response && response.headers && response.headers._headers.get('content-type')
      && response.headers._headers.get('content-type')[0] === 'text/csv; charset=utf-8') {
      return response._body;
    }
    if (response && response._body) {
      return JSON.parse(response._body.replace(/\\u0092/g, "'"));
    }

    return response;
  }

  public handleUnauthorized(resolve, reject, self, method, callbackArgs) {
    if (!localStorage.getItem('auth_refresh_token')) {
      resolve({ error: 'no_refresh_token'});
      localStorage.removeItem('auth_access_token');
      localStorage.removeItem('auth_expires_in');
      localStorage.removeItem('auth_refresh_token');
      localStorage.removeItem('auth_scope');
      localStorage.removeItem('auth_token_type');
      if (location.pathname === '/login') {
        return;
      }
      this.router.navigateByUrl('/login');
      return;
    }

    this.refreshToken()
    .then(() => {
      self[method](...callbackArgs)
      .then((response) => {
        resolve(this.parseMessage(response));
      }, (error) => {
        reject(this.parseMessage(error));
      });
    }, (error) => {
      resolve(this.parseMessage(error));
      localStorage.removeItem('auth_access_token');
      localStorage.removeItem('auth_expires_in');
      localStorage.removeItem('auth_refresh_token');
      localStorage.removeItem('auth_scope');
      localStorage.removeItem('auth_token_type');
      this.router.navigateByUrl('/login');
    });
  }

  public handleRequest(self, method, args, originalArgs, spinner = true) {
    if (spinner) {
      this.startSpinner();
    }
    return new Promise(
      (resolve, reject) => {
        this.activeRequest = self['http']
        [method](...args)
        .subscribe(
          (response: any) => {
            if (spinner) {
              this.stopSpinner();
            }
            resolve(this.parseMessage(response));
          },
          (error) => {
            if (spinner) {
              this.stopSpinner();
            }
            if (error.status === 401) {
              if (this.parseMessage(error) !== 'User account is disabled.') {
                this.handleUnauthorized(resolve, reject, self, method, originalArgs);
              } else {
                reject(this.parseMessage(error));
              }
            } else {
              reject(this.parseMessage(error));
            }
          }
        );
      }
    );
  }

  public refresh() {
    let body = {
      client_id: config.client_id,
      client_secret: config.client_secret,
      refresh_token: localStorage.getItem('auth_refresh_token'),
      grant_type: 'refresh_token'
    };
    return this.post('/oauth/v2/token', body);
  }

  public refreshToken() {
    if (RequestService.isRefreshingToken) {
      return RequestService.isRefreshingToken;
    }

    RequestService.isRefreshingToken = this.refresh()
    .then((response) => {
      localStorage.setItem('auth_access_token', response.access_token);
      localStorage.setItem('auth_expires_in', response.expires_in);
      localStorage.setItem('auth_refresh_token', response.refresh_token);
      localStorage.setItem('auth_scope', response.scope);
      localStorage.setItem('auth_token_type', response.token_type);
      RequestService.isRefreshingToken = null;
    });
    return RequestService.isRefreshingToken;
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/common/services/request.service.ts